import React, { useState, useMemo, useContext } from "react";
import { styled } from '@mui/system';
import {FirebaseContext} from "../../../context/firebase";
import { useNavigate } from "react-router-dom";
import AppBar from "../components/AppBar";
import { Grid } from "@mui/material";


interface Props {
  handleBeneficiaryOpen3: () => void;
  handleEnterPinOpen: () => void;
  setTransferActiveBeneficiary: React.Dispatch<React.SetStateAction<string>>;
  setTransferActiveBeneficiary2: React.Dispatch<React.SetStateAction<string>>;
  setTransferActiveBeneficiary3: React.Dispatch<React.SetStateAction<string>>;
  handleECCUOption1: () => void;
  handleOthersOption2: () => void;
  handleOthersOption3: () => void;
}

// --- MOVE styled component outside the React component so it is stable ---
const Main = styled("main")(({ theme }) => ({}));

const Beneficiaries: React.FC<Props> = ({
  handleBeneficiaryOpen3,
  handleEnterPinOpen,
  setTransferActiveBeneficiary,
  setTransferActiveBeneficiary2,
  setTransferActiveBeneficiary3,
  handleECCUOption1,
  handleOthersOption2,
  handleOthersOption3,

}) => {
    const { data, error, refresh } = useContext(FirebaseContext);

  const navigate = useNavigate();

  // keep original list stable
  const beneficiaries = useMemo(() => {
    const same = Array.isArray(data?.beneficiarySame)
      ? data.beneficiarySame
      : data?.beneficiarySame
      ? [data.beneficiarySame]
      : [];

    const other = Array.isArray(data?.beneficiaryOther)
      ? data.beneficiaryOther
      : data?.beneficiaryOther
      ? [data.beneficiaryOther]
      : [];

    return [...same, ...other];
  }, [data]);

  const [search, setSearch] = useState("");

  // filter only, don't recreate the base list
  const filteredList = useMemo(() => {
    if (!search.trim()) return beneficiaries;
    const q = search.toLowerCase();
    return beneficiaries.filter(item =>
      item.name.toLowerCase().includes(q) ||
      item.accountNumber.toLowerCase().includes(q) ||
      item.bank.toLowerCase().includes(q)
    );
  }, [search, beneficiaries]);

  const sendMoney = (item: any) => {
    if (item.bank === "ECCU") {
      setTransferActiveBeneficiary2("Choose Beneficiary");
      setTransferActiveBeneficiary(item.name);
    } else {
      setTransferActiveBeneficiary("Choose Beneficiary");
      setTransferActiveBeneficiary2(item.name);
    }
    navigate("/dashboard/transfer-funds");
  };

  return (
    <Main id="content">
      <AppBar />

      <section className="container">
        <ul className="ben-page-nav ben-page-nav-tabs" id="PageNavigator">
          <li className="ben-page-nav-item">
            <a className="ben-page-nav-link active">Beneficiaries</a>
          </li>
        </ul>

        <div className="ben-groom-panel">
          <div>
            <div style={{ paddingTop: "3rem" }}></div>
            <div className="ben-groom-panel-inner">
              <div className="ben-groom-panel-inner-measure">
                <Grid container className="ben-res-pad" style={{ marginBottom: "1rem" }}>
                  <Grid item xs={12} md={5} style={{ marginBottom: "0.5rem" }}>
                    <input
                      name="globalSearch"
                      className="ben-form-control transSearch"
                      placeholder="Search Beneficiaries"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}></Grid>
                  <Grid item xs={12} md={3} style={{ marginBottom: "0.5rem" }}>
                    <button onClick={handleBeneficiaryOpen3} className="btn shupNew w-100">
                      <img src="/imgs/plus.svg" style={{ marginRight: "0.5rem" }} alt="plus" />
                      Add New
                    </button>
                  </Grid>
                </Grid>

                <Grid container className="ben-res-pad">
                  <Grid item xs={12}>
                    <div className="ben-table-responsive">
                      <table className="ben-table" id="beneficiary">
                        <thead>
                          <tr>
                            <th>Account Holder</th>
                            <th>Bank</th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredList.length > 0 ? (
                            filteredList.map((item: any) => (
                              <tr key={item.id}>
                                <td>
                                  <div className="mint-row">
                                    <div className="block-circle" style={{ marginRight: "0.5rem" }}>{item.initial}</div>
                                    <div className="taylor">
                                      <h6 className="mb-0">{item.name}</h6>
                                      <p className="mb-0">{item.accountNumber}</p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="mint-row">
                                    <div className="taylor">
                                      <h6 className="mb-0" style={{ marginTop: '2px' }}>{item.bank}</h6>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <button
                                    className="btn send-money mx-auto"
                                    style={{ marginTop: "0.5rem", color: '#d1a23c', fontWeight: '600' }}
                                    onClick={() => sendMoney(item)}
                                  >
                                    Send Money
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn remove-bene mx-auto"
                                    style={{ marginTop: "0.5rem", color: '#d1a23c', fontWeight: '600' }}
                                    onClick={handleEnterPinOpen}
                                  >
                                    Remove
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr><td colSpan={4} style={{ textAlign: 'center' }}>No Beneficiary Found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Main>
  );
};

export default Beneficiaries;
